<template>
  <div class="collect-page collect-card">
    <div class="mains-content">
      <div class="page-left">
        <div class="member-box"><member ref="member" :mobile="formMobile" @handleUser="memberChange"></member></div>
        <div class="right-box">
          <div v-if="!form.memberId" class="right-box-empty">
            <div class="right-box-empty-img">
              <img src="../../../assets/images/new/empty.png" alt="">
              <div class="color999 fontSize16 mt30">请选择会员后进行操作</div>
            </div>
          </div>
          <div v-else>
            <el-form
              ref="form"
              :model="form"
              class="plr24 pt16"
              label-width="120px"
              label-position="left"
            >
              <el-form-item
                ref="walletAmount"
                label="账户本金："
                prop="walletAmount"
                class="flex-row"
              >
                <p v-if="list.baseAmount">￥{{list.baseAmount}}</p>
                <p v-else>-</p>
              </el-form-item>
              <el-form-item
                ref="giveAmount"
                label="账户赠金："
                prop="giveAmount"
                class="flex-row"
              >
                <p v-if="list.giveAmount">￥{{list.giveAmount}}</p>
                <p v-else>-</p>
              </el-form-item>
              
              <el-form-item
                ref="walletAmount"
                label="提现金额："
                prop="walletAmount"
                class="flex-row"
              >
                <el-input v-model.trim="form.walletAmount" placeholder="请输入金额" maxlength="8" />
              </el-form-item>
              <el-form-item
                ref="giveAmount"
                label="扣除赠金："
                prop="giveAmount"
                class="flex-row"
              >
                <el-input v-model.trim="form.giveAmount" class="input" placeholder="请输入金额" maxlength="8" />
              </el-form-item>
              <el-form-item
                ref="giveAmount"
                label="备注："
                prop="giveAmount"
                class="flex-row remark"
              >
                <el-input v-model="form.remark" type="textarea" placeholder="请输入备注"></el-input>
              </el-form-item>
            </el-form>
            <div class="confirm-btn">
              <div class="flex-row space-between">
                <div class="msg">
                  <div class="nums total">
                    提现金额:
                    <span class="moneys fontSize20">￥<span class="fontSize28 fb">{{ form.walletAmount || 0 }}</span></span>
                  </div>
                  <div class="total">
                    扣除赠金:
                    <span class="moneys fontSize20">￥<span class="fontSize28 fb">{{ form.giveAmount || 0 }}</span></span>
                  </div>
                </div>
              </div>
            </div>
          </div>
			  </div>
        <el-button class="save_btn" @click="configCancelCard">确定提现</el-button>
      </div>
      <div class="left-box br10">
        <div class="cardFlex">
          <img src="../../../assets/images/new/recharge.png" alt="">
          <div class="pt24 fontSize16 color999">暂无其他内容</div>
        </div>
        <div class="foot-msg padding-no">
          <p class="infos">温馨提示:</p>
          <p>1.支持余额部分提现;</p>
          <p>2.赠送金额如果想回收，可以相应给会员扣减;</p>
        </div>
      </div>
    </div>
    <payDialog
      title="会员销卡效验"
      :bizType="'pay'"
      :hide="dialogHide"
      :oid="''"
      :memberId="form.memberId"
      :price="Number(form.walletAmount)"
      :type="'cancelCard'"
      :mobile="$store.getters.MemberMobile"
      :giveAmount="form.giveAmount"
      @changeDialog="savePay"
    ></payDialog>
    <withdrawal-card ref="withdrawalForm" @handleChange="withdrawalBack"></withdrawal-card>
  </div>
</template>

<script>
import minxin from "../../../assets/javascript/minxin.js";
import member from "../../components/member";
import payDialog from "../../components/pay-dialog";
import tips from "../../../components/tips";
import withdrawalCard from "../../components/withdrawal-card.vue";
export default {
  mixins: [minxin],
  components: { withdrawalCard, member, tips, payDialog},
  data() {
    return {
      addEditShow: false,
      addEditTitle: "会员销卡",
      dialogHide: false,
      paySuccessHide: false,
      textarea: "",
      form: {
        walletAmount: null,
        memberId: "",
        remark: ""
      },
      formMobile: '',
      memberForm: {},
      list: {},
      memberBgHide: false,
      cancelMobile: "",
      moneys: "",
      payWayForm: {},
      userInfo: {},
      headImgUrl: "https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png",
    };
  },
  watch: {
    
  },
  created() {
  
  },
  mounted() {
    
  },
  destroyed () {
    
  },
  methods: {
    payMoney(org) {
      console.log("org: ", org);
    },
    memberChange(row) {
      console.log(row);
      if (row) {
        this.list = row;
        this.userInfo = row;
        this.form.memberId = row.id;
        this.moneys = row.walletAmount;
      } else {
        this.form = {
          walletAmount: null,
          memberId: "",
          remark: ""
        }
      }
    },
    configCancelCard() {
      this.form.walletAmount = this.form.walletAmount ? Number(this.form.walletAmount) : '';
      this.list.baseAmount = this.list.baseAmount ? Number(this.list.baseAmount) : 0;
      if (this.form.memberId == "") {
        this.$message.warning("请选择会员");
        return false;
      } else if (!this.form.walletAmount && !this.form.giveAmount) {
        this.$message.warning("请输入金额");
        return false;
      } else if (this.form.walletAmount == 0 && this.form.giveAmount == 0) {
        this.$message.warning("请输入金额");
        return false;
      } else if (this.form.walletAmount > this.list.baseAmount) {
        
        this.$message.warning("提现金额不能大于会员卡余额");
        return false;
      } else if (Number(this.form.giveAmount) > Number(this.list.giveAmount)) {
        this.$message.warning("扣除赠金不能大于账户赠金");
        return false;
      }
      if (!this.form.remark) {
        this.$message.warning("请输入备注");
        return false;
      }
      console.log(this.form);
      this.$refs.form.validate(valid => {
        if (valid) {
          this.dialogHide = true;
        }
      });
    },
    savePay(value) {
      if (value != "") {
        let arr = {}
        if (this.form.giveAmount) {
          arr = {
            remark: this.form.remark,
            payCheckType: value.payCheckType,
            verifyCode: value.verifyCode,
            memberId: this.form.memberId,
            amount: this.form.walletAmount==""?0:this.form.walletAmount,
            payCode: this.payWayForm.payCode,
            giveAmount: this.form.giveAmount
          }
        } else {
          arr = {
            remark: this.form.remark,
            payCheckType: value.payCheckType,
            verifyCode: value.verifyCode,
            memberId: this.form.memberId,
            amount: this.form.walletAmount==""?0:this.form.walletAmount,
            payCode: this.payWayForm.payCode
          }
        }
        this.$api.post(this.$url.companyRefund.withdraw, JSON.stringify(arr)).then(res => {
          if (res) {
            this.$refs.withdrawalForm.$emit("set", this.form.walletAmount);
          }
        });
      } else {
        this.dialogHide = false;
      }
    },
    withdrawalBack () {
      this.dialogHide = false;
      this.addEditShow = false;
      this.$refs['form'].resetFields();
      this.form = {};
      this.formMobile = "";
      this.list = {};
      this.$refs.member.handleInputHide();
    }
  }
};
</script>

<style scoped lang="less">
@import "../../../assets/css/edit.less";

.cardFlex {
  height: calc(100vh - 224px);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    color: #999;
}

.mains-content {
  display: flex;
  height: 100%;
  .left-box {
    width: 60%;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    .tips-position {
      position: absolute;
      width: calc(100% - 74px);
      bottom: 16px;
    }
  }
}
.collect-card {
  height: calc(100vh - 58px);
  background-color: #e6edf5;
  padding: 16px;
  .groupDialog /deep/ .el-dialog__body {
    padding: 10px 20px;
    color: #111;
    height: 200px;
    overflow: auto;
  }
}
  .member-box {
    width: calc(100% - 48px);
    padding: 15px 16px;
    background: #3388ff;
    border-radius: 10px 10px 0px 0px;
	}
  .right-box {
    position: relative;
		background: url("../../../assets/images/new/footBath.png") no-repeat;
    background-position:center bottom;
    height: calc(100vh - 248px);
    margin-right: 16px;
		.right-box-empty {
      height: calc(100vh - 248px);
      display: flex;
      justify-content: center;
      align-items: center;
      .right-box-empty-img {
        width: 191px;
        height: 170px;
      }
    }    
	}
.page-left {
  width: 40%;
  position: relative;
}
.save_btn {
  width: calc(100% - 16px);
  height: 68px;
  font-size: 20px;
  font-weight: bold;
  margin-top: 15px;
  color: #fff;
  background: #FF5449;
}
/deep/ .el-input__prefix {
  color: #111;
  display: flex;
  align-items: center;
  font-size: 16px;
}
/deep/ .el-form-item__content {
  margin-left: 0 !important;
}
.remark /deep/ .el-form-item__content {
  flex: 1;
}
.confirm-btn {
  position: absolute;
  bottom: 0;
  width: calc(100% - 32px);
  display: flex;
  align-items: center;
  margin: 0 16px;
  border-top: 1px solid #EBEDF0;
  padding: 12px 0;
  .flex-row {
    width: 100%;
    align-items: center;
    
    .msg {
      width: 100%;
      display: flex;
      justify-content: flex-end;
      font-weight: 500;
      .nums {
        margin-right: 40px;
      }
    }
  }
}
.padding-no {
  padding: 10px 20px 0;
}
.foot-msg {
  background: #FBFBFC;
  border: 1px solid #E5E5E5;
  border-radius: 4px;
  margin: 0 24px;
  color: #999;
  p {
    margin-bottom: 10px;
  }
  .infos {
    color: #ff892a;
    margin-bottom: 20px;
  }
}
</style>
